import { render, staticRenderFns } from "./play-button.vue?vue&type=template&id=188f4a00&"
import script from "./play-button.vue?vue&type=script&lang=js&"
export * from "./play-button.vue?vue&type=script&lang=js&"
import style0 from "./play-button.vue?vue&type=style&index=0&id=188f4a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports